import { z } from "zod";
export const twinDeviceIdSchema = z.string().trim().min(1).max(200);
export const twinDeviceRegisterInputSchema = z.object({
    /** The APNs device token, hex. */
    token: z.string().trim().min(1).max(400).describe("The APNs device token."),
    /** Which APNs the token belongs to, as the build's provisioning says. */
    environment: z.enum(["sandbox", "production"]).describe("Which APNs the token belongs to, as the build's provisioning says."),
    appVersion: z.string().trim().min(1).max(100),
    /**
     * The organisation the client is signed in to, as its sign-in names it (the token's `mlx_organisation_id`); it must
     * be the request's own. Never the tenant's own id for it, which the client doesn't see.
     */
    organisationId: z.string().trim().min(1).max(200)
        .describe("The organisation the client is signed in to, as its sign-in names it (the token's mlx_organisation_id)."),
}).strict().meta({ title: "TwinDeviceRegisterInput" });
/** A registered device, without its token. */
export const twinDeviceSchema = z.object({
    deviceId: z.string().min(1),
    environment: z.enum(["sandbox", "production"]),
    appVersion: z.string().nullable(),
    organisationId: z.string().min(1).describe("The organisation the device is registered for, as its sign-in names it."),
    lastSeenAt: z.number().int().nonnegative(),
}).strict().meta({ title: "TwinDevice" });
export const twinDeviceRegisterResponseSchema = z.object({ device: twinDeviceSchema }).strict().meta({ title: "TwinDeviceRegisterResponse" });
export const twinDeviceRemoveResponseSchema = z.object({ ok: z.literal(true) }).strict().meta({ title: "TwinDeviceRemoveResponse" });
/** What waits on the person, by the notification's primary reason: one thread a kind on the phone. */
export const TWIN_PUSH_KINDS = ["approval", "mention", "reply", "assignment", "share"];
export const twinPushKindSchema = z.enum(TWIN_PUSH_KINDS);
/**
 * What an alert push carries besides its `aps`: ids only, never words (decision D4). `item` is the Inbox item's id as
 * the Inbox lists it (`workspace-notification:<id>`), which MLX's `/inbox/open?item=` opens. `organisationId` is, in the
 * queued record, the tenant's own id for the organisation, by which the dispatcher finds the person's devices; in the
 * push a device receives, the organisation as that device's sign-in names it, the id it registered with.
 */
export const twinPushPayloadSchema = z.object({
    organisationId: z.string().min(1),
    kind: twinPushKindSchema,
    item: z.string().min(1),
}).strict();
/** The notification category every Twin push names, whose placeholder iOS shows when previews are hidden. */
export const TWIN_PUSH_CATEGORY = "twin.item";
/** The lock screen's words: the kind alone, no names or words of the organisation's (decision D4). */
export const TWIN_PUSH_ALERTS = {
    approval: "Approval needed in your Twin",
    mention: "You were mentioned in your Twin",
    reply: "You have a reply in your Twin",
    assignment: "Something was assigned to you in your Twin",
    share: "Something was shared with you in your Twin",
};
